<template>
<nav v-if="totalPages > 1" class="mt-7 d-flex justify-center align-center ga-1" aria-label="Paginering">
  <v-btn
    :to="currentPage > 1 ? linkTo(currentPage - 1) : undefined"
    :disabled="currentPage === 1"
    rel="prev"
    variant="text"
    icon="mdi-chevron-left"
    aria-label="Vorige pagina"
  />

  <v-btn
    v-for="page in pages"
    :key="page"
    :to="linkTo(page)"
    variant="text"
    icon
    :active="page === currentPage"
    :aria-current="page === currentPage ? 'page' : undefined"
  >{{ page }}</v-btn>

  <v-btn
    :to="currentPage < totalPages ? linkTo(currentPage + 1) : undefined"
    :disabled="currentPage === totalPages"
    rel="next"
    variant="text"
    icon="mdi-chevron-right"
    aria-label="Volgende pagina"
  />
</nav>


</template>

<script setup>
const route = useRoute();

const props = defineProps({
  total: { type: Number, required: true },
  perPage: { type: Number, default: 4 },
  queryKey: { type: String, default: "page" },
});

const totalPages = computed(() => Math.max(1, Math.ceil(props.total / props.perPage)));

const currentPage = computed(() =>
  Math.min(Math.max(1, Number(route.query[props.queryKey]) || 1), totalPages.value)
);

const pages = computed(() =>
  Array.from({ length: totalPages.value }, (_, i) => i + 1)
);

function linkTo(page) {
  const query = { ...route.query };
  if (page === 1) {
    delete query[props.queryKey];
  } else {
    query[props.queryKey] = page;
  }
  return { path: route.path, query };
}
</script>

<style scoped>
.pagination-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  border-radius: 4px;
  text-decoration: none;
  color: rgb(var(--v-theme-on-surface));
  font-size: 0.875rem;
}
.pagination-link:hover {
  background: rgba(var(--v-theme-on-surface), 0.08);
}
.pagination-link--active {
  background: rgb(var(--v-theme-primary));
  color: rgb(var(--v-theme-on-primary));
}
</style>